import React from 'react';

// Simple markdown renderer that handles basic formatting without Node.js dependencies
const SimpleMarkdown = ({ children }) => {
  if (!children || typeof children !== 'string') {
    return <span>{children}</span>;
  }

  // Simple regex-based markdown parsing for common patterns
  let text = children;
  
  // Convert **bold** to <strong>
  text = text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  
  // Convert *italic* to <em>
  text = text.replace(/\*(.*?)\*/g, '<em>$1</em>');
  
  // Convert `code` to <code>
  text = text.replace(/`(.*?)`/g, '<code style="background-color: #f5f5f5; padding: 2px 4px; border-radius: 3px; font-family: monospace;">$1</code>');
  
  // Convert [link](url) to <a>
  text = text.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');
  
  // Convert line breaks to <br>
  text = text.replace(/\n/g, '<br />');
  
  // Convert # headers (basic support)
  text = text.replace(/^### (.*$)/gm, '<h3>$1</h3>');
  text = text.replace(/^## (.*$)/gm, '<h2>$1</h2>');
  text = text.replace(/^# (.*$)/gm, '<h1>$1</h1>');
  
  // Convert bullet points
  text = text.replace(/^\* (.*$)/gm, '<li>$1</li>');
  text = text.replace(/(<li>.*<\/li>)/s, '<ul>$1</ul>');
  
  return (
    <span 
      dangerouslySetInnerHTML={{ __html: text }}
      style={{ whiteSpace: 'pre-wrap' }}
    />
  );
};

export default SimpleMarkdown;